import { render } from "./ServicesDestails.vue?vue&type=template&id=74470730&scoped=true"
import script from "./ServicesDestails.vue?vue&type=script&lang=js"
export * from "./ServicesDestails.vue?vue&type=script&lang=js"

import "./ServicesDestails.vue?vue&type=style&index=0&id=74470730&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74470730"]])

export default __exports__